import { FC } from 'react';
import Grid from '@material-ui/core/Grid';
import {
    Avatar,
    Button,
    Card,
    CardActions,
    CardContent,
    Typography,
    useMediaQuery,
} from '@material-ui/core';

interface Props {
    title: string;
    body: string;
    icon: string;
    onDelete: () => void;
}

const Device: FC<Props> = ({ title, body, icon, onDelete }) => {
    const matches = useMediaQuery('(max-width:600px)');
    return (
        <Grid item xs={matches ? 12 : 'auto'}>
            <Card>
                <CardContent>
                    <Avatar>
                        <i className={icon} />
                    </Avatar>
                    <Typography variant="h6">{title}</Typography>
                    <Typography variant="body2">{body}</Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" color="primary" onClick={onDelete}>
                        Disconnect
                    </Button>
                </CardActions>
            </Card>
        </Grid>
    );
};

export default Device;
